import script from "./dashboard-overview-title.vue?vue&type=script&setup=true&lang=ts"
export * from "./dashboard-overview-title.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__